import React from "react";
import AzureMP from './AzureMP';
import { Input, Button } from 'antd';

let streamUrl = '', widewineToken = '', fairplayToken = '', fairplayUrl = '';
let testUrl = '//amssamples.streaming.mediaservices.windows.net/3b970ae0-39d5-44bd-b3a3-3136143d6435/AzureMediaServicesPromo.ism/manifest';
let testUrl2 = 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4';

class TestStream extends React.Component {

    constructor(props) {
        super(props);
        this.state = { loadPlayer: false };
    }
    componentDidMount() {
        console.log('player did mount.');
    }
    componentWillUnmount() {
        console.log('player unmounted.');
    }
    submit = () => {
        console.log('submit called');
        this.setState({ loadPlayer: true });
    }
    render() {
        let { loadPlayer } = this.state;
        console.log('streamUrl=',streamUrl);
        let srcObj = { src: streamUrl };
        if(widewineToken || fairplayToken) {
            srcObj['protectionInfo'] = [{
                type: "Widevine",
                authenticationToken: "Bearer="+widewineToken
                }, {
                type: "FairPlay",
                certificateUrl: fairplayUrl,
                authenticationToken: "Bearer="+fairplayToken
            }];
        }
        return (
            <div style={{ padding: 80, width: '100%', height: window.innerHeight, backgroundColor: '#808080' }}>
                <div style={{ display: 'flex', flex:1, height: 54, marginBottom: 12 }}>
                    <Input placeholder="Streaming Url" onChange={(e)=>{ streamUrl = e.target.value }} name="streamUrl" id="streamUrl" />
                </div>
                <div style={{ display: 'flex', flex:1, height: 54, marginBottom: 12 }}>
                    <Input placeholder="Widewine Token" onChange={(e)=>{ widewineToken = e.target.value }}  />
                </div>
                <div style={{ display: 'flex', flex:1, height: 54, marginBottom: 12 }}>
                    <Input placeholder="Fairplay Token" onChange={(e)=>{ fairplayToken = e.target.value }}  />
                </div>
                <div style={{ display: 'flex', flex:1, height: 54, marginBottom: 12 }}>
                    <Input placeholder="Fairplay Certificate Url" onChange={(e)=>{ fairplayUrl = e.target.value }}  />
                </div>
                <Button onClick={() => { this.submit() }} style={{ width: '100%', height: 48, marginBottom: 12 }}>Submit</Button>
                { loadPlayer
                ?                
                    <div style={{ display: loadPlayer ? 'flex' : 'none', justifyContent: 'center', alignItems: 'center',
                    marginLeft: '25%', width: '50%' }}>
                        <AzureMP
                            skin="amp-flush"
                            options={{ autoplay: true }}
                            src={[srcObj]}
                            qrcodeInfo={[]}
                            updateCDN={(needRefresh)=>{ console.log('needRefresh.') }}
                            onDatabaseEvents={(eventDetails) => { console.log('on Database events called.') }}
                            onInstanceCreated={(ref) => { console.log('onInstanceCreated called'); }}
                            videoStarted={()=>{ console.log('videoStarted called'); }}
                            onVideoComplete={()=>{ console.log('onVideoComplete called'); }}
                            currentUrl={testUrl}
                            currentCountry={'India'}
                            locatorName={''}
                            widewineToken={widewineToken}
                            subtitles={[]}
                            streamWidth={1080}
                            streamHeight={720}
                            userId={3}
                            uploadId={3}
                            movieTime={1000}
                            waterMarkValue={''}
                            usersubtitle={''}
                            />
                    </div>
                :
                <div />
                }
            </div>
        );
    }
}
export default TestStream;